import { lazy } from 'react'

import {
  NavigationRoutesFn,
  buildModuleRoute,
  buildNavigation,
} from 'modules/core/lib/react-router'

type Routes = ReturnType<NavigationRoutesFn>
type Navigation = Parameters<NavigationRoutesFn>[0]

const RootPage = lazy(() => import('modules/pages/pages/RootPage'))
const MainPage = lazy(() => import('modules/pages/pages/MainPage'))

export const pagesRoutes = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      path: navigation.pages.path,
      element: <RootPage />,
      handle: {
        module: 'pages',
        moduleName: () => 'Pages',
        meta: ({ navigate }) => {
          if (location.pathname === navigation.pages.fullPath()) {
            navigate(navigation.pages.all.fullPath())
          }
          return { title: 'Pages' }
        },
      },

      children: [...allPages(navigation)],
    }),
  ]
})

function allPages(navigation: Navigation): Routes {
  return [
    {
      path: navigation.pages.all.path,
      element: <MainPage />,
    },
  ]
}
